import { useCallback } from 'react';
import type { MessageDeliveryStatus, MessagePlaceholderDataObject } from '#models/services';

type CreatePlaceholderMessage = {
  chatroomId: string;
  createdAt?: string;
  messageId: string;
  payload?: MessagePlaceholderDataObject['payload'];
  status: MessageDeliveryStatus;
  text?: string;
  updatedAt?: string;
};

export const useCreatePlaceholderMessage = () =>
  useCallback(
    ({
      chatroomId,
      createdAt,
      messageId,
      payload,
      status,
      text,
      updatedAt,
    }: CreatePlaceholderMessage): MessagePlaceholderDataObject => {
      const now = new Date().toISOString();

      return {
        _id: messageId,
        chatroom: chatroomId,
        createdAt: createdAt ?? now,
        payload: payload ?? [],
        status,
        text,
        type: 'message-placeholder',
        updatedAt: updatedAt ?? now,
      };
    },
    [],
  );
